import { styled } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { typography } from '@/styles/helpers';

interface IScMissionPromoSectionProps {
  showFullInfo?: boolean;
}

export const ScMissionPromoSection = styled.div<IScMissionPromoSectionProps>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .info {
    display: flex;
    flex-direction: column;
    ${typography.body1regular}
    letter-spacing: 0.16px;

    span b {
      margin-right: 8px;
    }

    .level-info {
      display: flex;
      align-items: center;
      gap: 8px;

      .text {
        width: 100%;
        display: flex;
        flex-direction: column;
      }

      .reward {
        ${typography.body1bold};
        background: linear-gradient(180deg, #ffad01 0%, #ff5f00 118.75%);
        background-clip: text;
        color: transparent;
      }

      & > .addons {
        display: flex;
        align-items: center;
        gap: 4px;

        & > img {
          flex-shrink: 0;
        }

        & > i {
          transform: rotate(
            ${({ showFullInfo }) => (showFullInfo ? '-90deg' : '90deg')}
          );
          transition: stroke 0.3s ease;

          color: ${({ theme, showFullInfo }) =>
            showFullInfo ? theme.whiteColor : theme.blackLightColor};
        }
      }
    }
  }

  & .addons .circle {
    background-image: url(${getCDNImageUrl('/mission/menu-bg.webp')});
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 360px;

    & .character {
      width: 40px;
      height: 40px;
    }
  }

  .loginBtn {
    min-width: 0;
  }
  /*  */
  .timer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    line-height: 16px;

    span {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0.36px;
    }

    .value {
      min-width: 24px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.48px;
    }

    .text {
      font-size: 12px;
      line-height: 12px;
    }
  }
`;
